import { useCallback, useEffect, useMemo, useRef } from 'react'
import throttle from 'lodash-es/throttle'

export function useThrottleFunc(callback, throttleTime = 300) {
  const callbackRef = useRef(null)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  const throttledCallback = useMemo(
    () =>
      throttle(
        // callback is invoked from the throttle timer / event listener, never
        // during render. Reading callbackRef inside keeps the latest callback
        // without re-creating the throttle timer on every callback identity change.
        // eslint-disable-next-line react-hooks/refs
        (...args) => callbackRef.current?.(...args),
        throttleTime
      ),
    [throttleTime]
  )

  useEffect(
    () => () => {
      throttledCallback.cancel()
    },
    [throttledCallback]
  )

  const cancelThrottle = useCallback(() => {
    throttledCallback.cancel()
  }, [throttledCallback])

  return {
    cancelThrottle,
    throttledHandler: throttledCallback,
  }
}
